module.exports = __webpack_public_path__ + "assets/media/evening.a9526dbe.mp3";